import { tva } from '../../tailwind/merge'
import { isWeb } from '@gluestack-ui/utils/nativewind-utils'

// NB: `font-sans` intentionally removed from the base. The AOS Text/Textarea
// wrappers always supply a Manrope weight family class (font-regular/-medium/
// -semiBold/-bold/…). `font-sans` is emitted later in the Tailwind cascade than
// the weight font-family rules, and tailwind-merge can't dedupe it against the
// weight keys that collide with default Tailwind weight names (light/medium/
// bold) — so leaving it here made those weights fall back to the OS sans font
// instead of Manrope (AOS-808).
const baseStyle = isWeb
    ? 'my-0 bg-transparent border-0 box-border list-none text-start no-underline whitespace-pre-wrap break-words'
    : ''

export const textStyle = tva({
    base: `text-typography-700 font-body ${baseStyle}`,

    variants: {
        isTruncated: {
            true: 'web:truncate',
        },
        bold: {
            true: 'font-bold',
        },
        underline: {
            true: 'underline',
        },
        strikeThrough: {
            true: 'line-through',
        },
        size: {
            '2xs': 'text-2xs',
            'xs': 'text-xs',
            'sm': 'text-sm',
            'md': 'text-base',
            'lg': 'text-lg',
            'xl': 'text-xl',
            '2xl': 'text-2xl',
            '3xl': 'text-3xl',
            '4xl': 'text-4xl',
            '5xl': 'text-5xl',
            '6xl': 'text-6xl',
        },
        sub: {
            true: 'text-xs',
        },
        italic: {
            true: 'italic',
        },
        highlight: {
            true: 'bg-yellow-500',
        },
    },
})
